
import Dialog from '../../../../../../../../../../../BaseComponents/Dialog/EDDialog';
import EDTypography from '../../../../../../../../../../../BaseComponents/Typography/EDTypography';

interface IProps {
  open: boolean;
  benamning: string;
  lokalGemensam?: boolean;
  toggleOpen: () => void;
  deleteAnalys: () => void;
}

/**
 * En varning/konfirmeringsdialog som visas när användaren försöker ta bort en analys.
 */
const EkonomiskAnalysDeleteAnalysConfirmation: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => (
  <Dialog
    title="Ta bort analys"
    open={props.open}
    onClose={props.toggleOpen}
    footerActions={[
      { label: 'Avbryt', onClick: props.toggleOpen },
      { label: 'Ta bort', onClick: props.deleteAnalys },
    ]}
  >
    <EDTypography>
      {props.lokalGemensam
        ? 'Du har markerat att du vill ta bort den gemensamma analysen'
        : 'Du har markerat att du vill ta bort den egna analysen'}{' '}
      <EDTypography component="span" bold>
        {props.benamning}
      </EDTypography>
      .
      <br />
      {props.lokalGemensam
        ? 'Analysen kommer tas bort helt för de användare som nyttjar den.'
        : 'Analysen kommer tas bort helt och visas därefter ej i kombination med någon av dina kodbehörigheter.'}
      <br />
      Vill du verkligen ta bort den?
    </EDTypography>
  </Dialog>
);

export default EkonomiskAnalysDeleteAnalysConfirmation;
